import React, { useState } from 'react';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

// Collapsing removes the rows the user has scrolled past. Instead of a separate
// smooth scroll with its own timing, follow the panel's height frame by frame so the
// scroll back to the section heading runs at exactly the speed the accordion closes.
function scrollWithCollapse(section) {
    const panel = section.querySelector('.accordion-collapse');
    const header = document.querySelector('header');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const target = section.getBoundingClientRect().top + window.scrollY - headerHeight;
    const start = window.scrollY;
    const distance = start - target;
    if (!panel || distance <= 0) return;

    const startHeight = panel.getBoundingClientRect().height;
    const deadline = performance.now() + 2000;
    let cancelled = false;
    const cancel = () => {
        cancelled = true;
    };
    window.addEventListener('wheel', cancel, { once: true, passive: true });
    window.addEventListener('touchmove', cancel, { once: true, passive: true });

    const step = () => {
        if (cancelled) return;
        const height = panel.getBoundingClientRect().height;
        const progress = startHeight > 0 ? Math.min(1, 1 - height / startHeight) : 1;
        if (progress >= 1 || performance.now() > deadline) {
            window.scrollTo({ top: target, behavior: 'instant' });
            window.removeEventListener('wheel', cancel);
            window.removeEventListener('touchmove', cancel);
            return;
        }
        window.scrollTo({ top: start - distance * progress, behavior: 'instant' });
        requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
}

export function PressCustomToggle() {
    const [showMore, setShowMore] = useState(false);
    const decoratedOnClick = useAccordionButton('0', (event) => {
        if (showMore) scrollWithCollapse(event.currentTarget.closest('section'));
        setShowMore(!showMore);
    });
    return (
        <div className="text-center pb-4">
            <button
                type="button"
                className="milan-btn milan-navy-btn"
                aria-expanded={showMore}
                onClick={decoratedOnClick}
            >
                {!showMore ? 'Show More' : 'Show Less'}
            </button>
        </div>
    );
}

export default PressCustomToggle;
